import { motion } from "framer-motion";

const steps = [
  {
    number: "1",
    title: "Get Started for Free",
    description:
      "Create your account and start your 7-day free trial. Access anytime, on any device.",
  },
  {
    number: "2",
    title: "Explore and Learn",
    description:
      "Browse guided courses, workshops, and tools that help you recognize abuse and rebuild discernment.",
  },
  {
    number: "3",
    title: "Heal at Your Own Pace",
    description:
      "Journal, check in daily, track your progress, and connect with trained advocates, all confidentially.",
  },
  {
    number: "4",
    title: "Get Certified",
    description:
      "Earn your Soul Safe certification and become a trained reformer who helps build safer churches.",
  },
];

export function CertificationPathway() {
  return (
    <section className="py-28 md:py-36 bg-background">
      <div className="container px-6">
        {/* Section header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-3xl mx-auto text-center mb-20"
        >
          <p className="text-sm font-semibold uppercase tracking-[0.25em] text-accent mb-6">
            How It Works
          </p>
          <h2
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-4 leading-[1.05]"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Your Step-by-Step Path to
            <br />
            Healing and Discernment
          </h2>
          {/* Hand-drawn underline SVG */}
          <svg
            viewBox="0 0 320 16"
            className="mx-auto w-56 md:w-72 h-4 mt-2"
            fill="none"
          >
            <path
              d="M4 10 C60 4, 120 14, 160 8 S260 4, 316 10"
              stroke="hsl(43, 45%, 65%)"
              strokeWidth="2.5"
              strokeLinecap="round"
              fill="none"
            />
          </svg>
        </motion.div>

        {/* Steps */}
        <div className="max-w-2xl mx-auto space-y-20 md:space-y-24">
          {steps.map((step, i) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="text-center"
            >
              {/* Hand-drawn numbered circle */}
              <div className="relative w-24 h-24 md:w-28 md:h-28 mx-auto mb-6">
                <svg
                  viewBox="0 0 100 100"
                  className="w-full h-full"
                  fill="none"
                >
                  {/* Imperfect hand-drawn circle */}
                  <ellipse
                    cx="50"
                    cy="50"
                    rx="42"
                    ry="40"
                    stroke="hsl(43, 40%, 70%)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    fill="none"
                    transform="rotate(-5, 50, 50)"
                    strokeDasharray="6 3"
                  />
                  <ellipse
                    cx="50"
                    cy="50"
                    rx="44"
                    ry="42"
                    stroke="hsl(43, 40%, 75%)"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    fill="none"
                    transform="rotate(3, 50, 50)"
                  />
                </svg>
                <span
                  className="absolute inset-0 flex items-center justify-center text-4xl md:text-5xl text-foreground/70"
                  style={{
                    fontFamily: "'Cormorant Garamond', serif",
                    fontStyle: "italic",
                  }}
                >
                  {step.number}
                </span>
              </div>

              <h3
                className="text-2xl md:text-3xl font-bold text-foreground mb-3"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                {step.title}
              </h3>
              <p className="text-base md:text-lg text-muted-foreground max-w-md mx-auto leading-relaxed">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="text-center mt-20 text-base text-muted-foreground/60 italic"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Every step is earned, never rushed. Your healing journey is yours.
        </motion.p>
      </div>
    </section>
  );
}
